<template>
    <tr class="table-row" @click="handleClick($event)" :class="{ loading: isLoading }">
        <slot :hidden="hidden" :filter="filter" :sort="sort">

        </slot>
    </tr>
</template>

<script>
import LoadingComponentMixin from "@mixins/LoadingComponentMixin";

export default {
    name: "DoctuTableRow",

    mixins: [
        LoadingComponentMixin
    ],

    methods: {
        handleClick: function (event) {
            this.$emit('click', this, event);
        }
    },

    computed: {
        hidden: function () {
            return this.$parent.hidden;
        },

        filter: function () {
            return this.$parent.filter;
        },

        sort: function () {
            return this.$parent.sort;
        }
    }
}
</script>

<style>
.table-row:hover {
    cursor: pointer
}
</style>
